export default __webpack_public_path__ + "static/media/FounderImage.9ebdb110.svg";